var ButtonStatus;

(function (ButtonStatus) {
  ButtonStatus["ERROR"] = "status-error";
  ButtonStatus["WARNING"] = "status-warning";
  ButtonStatus["INFO"] = "status-info";
  ButtonStatus["SUCCESS"] = "status-success";
  ButtonStatus["NONE"] = "status-none";
})(ButtonStatus || (ButtonStatus = {}));

var ButtonType;

(function (ButtonType) {
  ButtonType["PRIMARY"] = "primary";
  ButtonType["SECONDARY"] = "secondary";
  ButtonType["DEFAULT"] = "default";
  ButtonType["LINK"] = "link";
  ButtonType["TEXT"] = "text";
  ButtonType["TEXT_REGULAR"] = "text-regular";
})(ButtonType || (ButtonType = {}));

var ButtonShape;

(function (ButtonShape) {
  ButtonShape["ROUND"] = "round";
})(ButtonShape || (ButtonShape = {}));

var ButtonSize;

(function (ButtonSize) {
  ButtonSize["LARGE"] = "large";
  ButtonSize["MIDDLE"] = "middle";
  ButtonSize["SMALL"] = "small";
})(ButtonSize || (ButtonSize = {}));

var ButtonBlock;

(function (ButtonBlock) {
  ButtonBlock["NONE"] = "block-none";
  ButtonBlock["MOBILE_UP"] = "block-mobile-up";
  ButtonBlock["MOBILE_DOWN"] = "block-mobile-down";
  ButtonBlock["TABLET_UP"] = "block-tablet-up";
  ButtonBlock["TABLET_DOWN"] = "block-tablet-down";
  ButtonBlock["DESKTOP_UP"] = "block-desktop-up";
  ButtonBlock["DESKTOP_DOWN"] = "block-desktop-down";
})(ButtonBlock || (ButtonBlock = {}));

var ButtonIconPosition;

(function (ButtonIconPosition) {
  ButtonIconPosition["LEFT"] = "left";
  ButtonIconPosition["RIGHT"] = "right";
  ButtonIconPosition["NONE"] = "";
})(ButtonIconPosition || (ButtonIconPosition = {}));

export { ButtonBlock, ButtonIconPosition, ButtonShape, ButtonSize, ButtonStatus, ButtonType };
//# sourceMappingURL=Button.types.js.map
